import {environment} from '../environments/environment';

export const _idTokenKey = environment.appId + '.ID_TOKEN';
export const _accessTokenKey = environment.appId + '.ACCESS_TOKEN';
export const _refreshTokenKey = environment.appId + '.REFRESH_TOKEN';
export const _userKey = environment.appId + '.USER_DATA';
export const _emailKey = environment.appId + '.EMAIL';
export const _userAccessLevelKey = environment.appId + '.USER_ACCESS_LEVEL';
